export const generateTickValues = (dataArrays, numTicks = 5) => {
	// Flatten the array and find the global min and max
	const allValues = dataArrays.flat();
	const minValue = Math.min(...allValues);
	const maxValue = Math.max(...allValues);

	// Adjust min and max by ±10%
	const adjustedMin = minValue * 0.9;
	const adjustedMax = maxValue * 1.1;

	// Generate evenly spaced tick values
	const step = (adjustedMax - adjustedMin) / (numTicks - 1);
	return Array.from({ length: numTicks }, (_, i) => +(adjustedMin + i * step).toFixed(2));
};
